import { render } from "./DoctorInfo.vue?vue&type=template&id=1ab61b16&scoped=true"
import script from "./DoctorInfo.vue?vue&type=script&lang=js"
export * from "./DoctorInfo.vue?vue&type=script&lang=js"

import "./DoctorInfo.vue?vue&type=style&index=0&id=1ab61b16&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/demo-plus.centrodeglaucoma.com/darmin-plus-modular/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ab61b16"]])

export default __exports__